import { useState } from "react";
import { CalendarDays } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export function rangeFor(preset, custom) {
  const today = startOfDay(new Date());
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  if (preset === "today") return { date_from: today.toISOString(), date_to: tomorrow.toISOString(), label: "Hari Ini" };
  if (preset === "7d") { const f = new Date(today); f.setDate(today.getDate() - 6); return { date_from: f.toISOString(), date_to: tomorrow.toISOString(), label: "7 Hari Terakhir" }; }
  if (preset === "month") { const f = new Date(today.getFullYear(), today.getMonth(), 1); return { date_from: f.toISOString(), date_to: tomorrow.toISOString(), label: "Bulan Ini" }; }
  if (preset === "custom" && custom.from) {
    const f = new Date(custom.from + "T00:00:00");
    const t = new Date((custom.to || custom.from) + "T00:00:00"); t.setDate(t.getDate() + 1);
    return { date_from: f.toISOString(), date_to: t.toISOString(), label: `${custom.from} s/d ${custom.to || custom.from}` };
  }
  return { label: "Semua" };
}

const PRESETS = [["all", "Semua"], ["today", "Hari Ini"], ["7d", "7 Hari"], ["month", "Bulan Ini"], ["custom", "Rentang"]];

export function DateFilter({ value, onChange }) {
  const [custom, setCustom] = useState({ from: value.custom?.from || ymd(new Date()), to: value.custom?.to || ymd(new Date()) });

  const pick = (preset) => onChange({ preset, custom });
  const applyCustom = () => onChange({ preset: "custom", custom });

  return (
    <div className="date-filter" data-testid="date-filter">
      <CalendarDays size={16} className="muted-icon" />
      <div className="chip-row">
        {PRESETS.map(([id, label]) => (
          <button key={id} className={`chip ${value.preset === id ? "active" : ""}`} onClick={() => pick(id)} data-testid={`date-preset-${id}`}>{label}</button>
        ))}
      </div>
      {value.preset === "custom" && (
        <div className="custom-range" data-testid="date-custom-range">
          <input type="date" className="text-input date-input" value={custom.from} max={custom.to} onChange={(e) => setCustom({ ...custom, from: e.target.value })} data-testid="date-from" />
          <span className="muted-sm">s/d</span>
          <input type="date" className="text-input date-input" value={custom.to} min={custom.from} onChange={(e) => setCustom({ ...custom, to: e.target.value })} data-testid="date-to" />
          <button className="btn-primary sm" onClick={applyCustom} data-testid="date-apply">Terapkan</button>
        </div>
      )}
    </div>
  );
}
